/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterUserActionKind = (typeof FilterUserActionKind)[keyof typeof FilterUserActionKind];

export const FilterUserActionKind = {
  user_action: 'user_action',
} as const;
